import { useMapStore } from '../store/useMapStore';

export const translations = {
  en: {
    // Sidebar Labels
    ESSENTIALS: 'ESSENTIALS',
    CIVIC: 'CIVIC',
    SAFETY: 'SAFETY',
    UTILITIES: 'UTILITIES',
    SETTINGS: 'SETTINGS',
    CULTURE_AND_HERITAGE: 'CULTURE & HERITAGE',
    NAMMA_ARASU: 'Namma Arasu',
    MANIFESTO: 'Manifesto',
    TRACKER: 'Tracker',
    NEWS: 'News',

    // Layers
    PINCODE: 'Post Offices',
    PDS: 'Ration Shops',
    HEALTH: 'Health Facilities',
    VETERINARY: 'Veterinary Services',
    VET_POLY_CLINIC: 'Poly Clinic',
    VET_CLINIC_CENTER: 'Clinician Centre',
    VET_HOSPITAL: 'Veterinary Hospital',
    VET_DISPENSARY: 'Veterinary Dispensary',
    VET_SUB_CENTER: 'Veterinary Sub-Center',
    LOCAL_BODIES_V2: 'Local Bodies',
    CONSTITUENCY: 'Constituencies',
    POLICE: 'Police Jurisdictions',
    TNEB: 'TNEB',
    REGISTRATION: 'Registration Offices',
    LAND_PARCEL: 'Survey No. Finder',
    TEMPLES: 'Temples (HRCE)',
    CORPORATION: 'Municipal Corporation',
    MUNICIPALITY: 'Municipality',
    VET_INSTITUTION: 'Veterinary Institution',
    TOWN_PANCHAYAT: 'Town Panchayat',
    VILLAGE_PANCHAYAT: 'Village Panchayat',
    UNKNOWN_LOCAL_BODY: 'Local Body',
    ABOUT_APP: 'About',
    LEGAL_PRIVACY: 'Legal',
    DISCLAIMER: 'Disclaimer',
    ATTRIBUTIONS: 'Credits',
    SOFTWARE_LIBRARIES: 'Software Libraries',
    MAP_INFRASTRUCTURE: 'Map Infrastructure',
    DATA_SOURCES_CREDITS: 'Data Sources & Credits',
    POWERED_BY: 'Powered By',
    DEVELOPED_USING: 'Developed Using',
    CORE_FRAMEWORKS: 'Core Frameworks',
    GIS_ENGINE: 'GIS & Logic Engine',
    UI_UX_DESIGN: 'UI/UX & Components',
    BACKEND_SERVICES: 'Backend & Operations',
    GOVT_DATA_PORTALS: 'Government Data Portals',

    // Singular sharing labels
    RATION_SHOP: 'Ration Shop',
    HEALTH_FACILITY: 'Health Facility',
    VETERINARY_FACILITY: 'Veterinary Facility',
    POLICE_STATION: 'Police Station',
    SRO: 'Sub Registrar Office',
    CONSTITUENCY_SINGLE: 'Constituency',
    LAND_DETAILS: 'Land Details',
    TEMPLE_FACILITY: 'Temple',
    CAT_TEMPLES: 'Temples (HRCE)',
    CAT_FUEL: 'Fuel Outlets',
    DEEP_LINK_HINT: 'Tap your location inside this area',
    SEARCHED_LOCATION: 'Searched Location',

    // Election Strings
    ELECTION_LIVE: 'Election Results 2026',
    ELECTION_PROVISIONAL_BANNER: 'Results are provisional and subject to ECI updates.',
    LAST_UPDATED: 'Last Updated',
    LEADING: 'Leading',
    WON: 'Won',
    TALLY_PROGRESS: 'Reporting',
    CONSTITUENCIES_COUNT: 'Constituencies',
    TOTAL_SEATS: 'Total Seats',
    LEADS_BY_PARTY: 'Partywise Standings',
    PARTY_DMK: 'DMK',
    PARTY_ADMK: 'AIADMK',
    PARTY_TVK: 'TVK',
    PARTY_CPI: 'CPI',
    PARTY_BJP: 'BJP',
    PARTY_INC: 'INC',
    PARTY_NTK: 'NTK',
    PARTY_PMK: 'PMK',
    PARTY_VCK: 'VCK',
    PARTY_OTHERS: 'Others',
    PARTY_NA: 'Waiting for Results',

    // UI Elements
    ABOUT_LEGAL: 'About & Legal',
    DARK_MODE: 'Dark Mode',
    LIGHT_MODE: 'Light Mode',
    LOCATING: 'Locating...',
    LOCATE_ME: 'Locating you...',
    LOCATING_SUBTEXT: 'Finding your exact area to provide local service details.',
    GPS_ACTIVE: 'GPS Active',
    SEARCH_PLACEHOLDER: 'Search for an area, pincode, or office...',
    EXPERIMENTAL: 'BETA',
    EXPERIMENTAL_TAG: 'EXPERIMENTAL',

    // Actions
    DIRECTIONS: 'GET DIRECTIONS',
    REPORT_ISSUE: 'Report an Issue',
    CLOSE: 'Close',
    CANCEL: 'Cancel',
    SEND: 'Send',
    COPY: 'Copy',
    VIEW_DETAILS: 'VIEW DETAILS',
    YES: 'Yes',
    NO: 'No',
    LATER: 'Maybe Later',

    // Administrative Labels
    DISTRICT: 'District',
    TALUK: 'Taluk',
    BLOCK: 'Block',
    WARD: 'Ward',
    ZONE: 'Zone',
    VILLAGE: 'Village',
    CATEGORY: 'Category',
    DIVISION: 'Division',
    CIRCLE: 'Circle',
    REGION: 'Region',
    STATE: 'State',
    AREA: 'Area',
    JURISDICTION: 'Jurisdiction',
    PIN_CODE: 'PIN Code',
    SURVEY_NUMBER: 'Survey Number',
    SUB_DIVISION: 'Subdivision',
    ULPIN: 'ULPIN',
    REVENUE_VILLAGE: 'Revenue Village',
    OFFICE_TYPE: 'Office Type',
    ABOUT_OFFICE: 'About this office',
    MORE_INFO: 'More Info',
    SHOP_CODE: 'Shop Code',
    INCHARGE: 'Incharge',
    CARE_LEVEL: 'Care Level',
    LOCAL_OFFICES: 'Local Offices',
    LOCATION: 'Location',
    LOCATIONS: 'Locations',
    COORDINATES: 'Coordinates',
    SURVEY_PARCEL: 'Survey Parcel',
    APPROX_AREA: 'Approx Area',
    REVENUE_WARD: 'Revenue Ward',
    REVENUE_BLOCK: 'Revenue Block',
    OUTSIDE_TN: 'Location is outside Tamil Nadu. Please provide a location within the state.',

    // Postal Specific Values
    HO: 'Head Post Office',
    SO: 'Sub Post Office',
    BO: 'Branch Post Office',
    PO: 'Post Office',
    DELIVERY: 'Delivery Office',
    NON_DELIVERY: 'Non-Delivery Office',
    POSTAL_DESC_DELIVERY: 'This post office delivers letters and parcels to nearby homes.',
    POSTAL_DESC_NON_DELIVERY: 'This office provides counter services but does not deliver mail directly.',

    // Facility Types
    MCH: 'Medical College Hospital',
    DH: 'District Hospital',
    SDH: 'Sub-District Hospital',
    CHC: 'Community Health Centre',
    PHC: 'Primary Health Centre',
    HSC: 'Health Sub-Centre',

    // Status & Instructions
    STATUS: 'Status',
    VERIFIED: 'Verified',
    UNAVAILABLE: 'Unavailable',
    INSTRUCTION: 'Instruction',
    NEXT_STEP: 'Next Step',
    MESSAGE: 'Message',
    NOTE: 'Note',
    REASON: 'Reason',
    HIGHLIGHTS: 'Highlights',
    ACTIVE_FILTERS: 'Active Filters',
    TIP: 'Tip',

    // Health/Postal Filters
    EMERGENCY: 'Emergency',
    DELIVERY_SERVICE: 'Delivery',
    DIAGNOSTICS: 'Diagnostics',
    STATEWIDE: 'Statewide',

    // Modals & Legal
    PRIVACY: 'Privacy',
    TERMS: 'Terms',
    DEVELOPER_INFO: 'Developer Information',
    CORRECTION_DETAILS: 'Correction Details',
    TECHNICAL_DETAILS: 'Technical Details',
    UPDATING: 'Updating...',

    // Legal & About Content
    NON_GOVT_TITLE: 'Non-Government Association',
    NON_GOVT_DESC: 'NammaMap is an independent, non-commercial research project. It is NOT affiliated with, endorsed by, or in any way officially connected to the Government of Tamil Nadu, the Government of India, or any of their agencies.',
    DATA_SOURCE_DESC: 'All data displayed on this portal is aggregated from publicly available government datasets, open data initiatives, and public records. While we strive for precision, the boundaries and locations should be used for informational purposes only.',

    ELECTION_DATA_TITLE: 'Electoral & Statistical Data',
    ELECTION_DATA_DESC: 'Election results, candidates, and counting summaries displayed are for analysis and research. Official declarations and verified tallies must be cross-referenced with state election authorities.',
    ZERO_DATA_TITLE: 'Zero-Data Policy',
    ZERO_DATA_DESC: 'NammaMap respects your privacy. We do not collect, store, or sell any Personal Identifiable Information (PII).',
    LOCATION_PRIVACY: 'When you use "Locate Me", your coordinates are processed locally in your browser. We never store your GPS history.',
    ACCEPTABLE_USE_TITLE: 'Acceptable Use',
    ACCEPTABLE_USE_DESC: 'By using NammaMap, you agree to use the service for lawful purposes. You may not attempt to scrape or disrupt the application infrastructure.',
    UNDERSTAND: 'I Understand',
    INDICATIVE_DATA_DISCLAIMER: 'Indicative parcel information sourced from TNGIS',

    // New General UI
    SKIP_TO_RESULTS: 'Skip to results',
    SEARCH_FOR_LOCATION: 'Search for a location',
    CLEAR_SEARCH: 'Clear search',
    LOCATE_ME_ARIA: 'Locate me',
    CLOSE_SIDEBAR: 'Close Sidebar',
    OPEN_SIDEBAR: 'Open Sidebar',
    SWITCH_TO_TAMIL: 'Switch to Tamil',
    SWITCH_TO_ENGLISH: 'Switch to English',
    SWITCH_TO_LIGHT_MODE: 'Switch to light mode',
    SWITCH_TO_DARK_MODE: 'Switch to dark mode',
    INDEPENDENT_PORTAL: 'Independent Tamil Nadu GIS Portal',
    ASSEMBLY: 'ASSEMBLY',
    PARLIAMENT: 'PARLIAMENT',
    HEALTH_EXPERIMENTAL_DESC: 'We are still refining the health facility discovery experience.',
    OR: 'or',
    SERVICE_LAYERS_ARIA: 'Service Layers',
    CLICK_FIND_TNEB: 'Click your location on the map to find your TNEB Section Office.',
    FIND_TNEB_SECTION: 'Find TNEB Section',
    TN: 'Tamil Nadu',

    // Result Card & Accuracy
    ACCURACY: 'Accuracy',
    VICINITY_DISCLAIMER: 'Vicinity only. The office is located within 200m of this point.',
    MATCH_CONFIDENCE: 'Match Confidence',
    CONFIDENCE_HIGH: 'High (Verified Jurisdictional Match)',
    CONFIDENCE_MEDIUM: 'Medium (Statewide Exact Match)',
    CONFIDENCE_LOW: 'Low (Near-Name Match)',
    GET_DIRECTIONS_FOR: 'Get directions for {{title}}',
    SHARE_CARD_FOR: 'Share card for {{title}}',
    MINIMIZE_CARD: 'Minimize Card',
    ZOOM_TO_PARCEL: 'Zoom to Parcel',
    CLEAR_SELECTION: 'Clear Selection',
    COPY_SURVEY: 'Copy Survey No.',
    SHARE_PARCEL: 'Share Parcel',
    COPY_LABEL: 'Copy {{label}}',
    SEARCH_RESULTS: 'Search Results',

    // Updates
    UPDATE_AVAILABLE: 'Update Available',
    UPDATE_PREPARING: 'Please wait while we prepare the new version.',
    UPDATE_READY: 'A newer version is ready with improvements.',
    REFRESH_NOW: 'REFRESH NOW',
    VIEW_RESULTS: 'VIEW RESULTS',
    TOTAL_VISITS: 'Unique Visitors',
    TODAY_VISITS: 'Visits Today',
    MINIMIZE: 'Minimize',
    EXPAND_FILTERS: 'Expand Filters',
    MINIMIZE_FILTERS: 'Minimize Filters',
    COMMUNITY_VERIFICATION: 'Community Verification',
    VERIFY_NOW: 'Is this information correct?',
    VERIFIED_BY: 'Verified by {{count}} people',
    THANK_YOU_VERIFY: 'Thank you for verifying!',
    YES_CORRECT: 'Yes, Correct',
    NO_INCORRECT: 'No, Incorrect',
    THANKS_REPORTING: 'Thanks for reporting!',
    SENDING: 'Sending...',
    SENT: 'Sent!',

    // Map Specific
    CLICK_TO_VIEW_JURISDICTION: 'Click to view jurisdiction',
    SECTION_OFFICE: 'Section Office',
    MOBILE: 'Mobile',
    EMAIL: 'Email',
    LOADING_HEALTH: 'Loading health facilities...',
    MAP_HIERARCHY: 'Map Hierarchy',
    MAJOR: 'Major',
    LOCAL: 'Local',
    SUB_CENTRE: 'Sub-Centre',
    LOC_RETRIEVE_ERROR: 'Could not retrieve your location. Please check your browser permissions.',
    LOC_NOT_SUPPORTED: 'Geolocation is not supported by your browser.',
    LOC_PERM_DENIED: 'Location access is blocked. Please enable it in your browser settings (click the lock icon in the address bar) and try again.',

    // Health Area Prompt
    FOCUS_AREA_REQUIRED: 'Focus Area Required',
    FOCUS_AREA_DESC: 'To show local health centres (PHC/HSC), please select a specific area or district.',
    USE_MY_LOCATION: 'Use My Current Location',
    USE_SEARCH_BAR: 'USE THE SEARCH BAR ABOVE',
    SEARCH_UNLOCK_DESC: 'Enter a Pincode, Block name, or District to unlock local facility discovery.',

    // Result Container & Instructions
    PDS_SHOPS_IN: 'PDS Shops in',
    DISPLAYING_LOCAL_SHOPS: 'Displaying all local shops',
    CLICK_MARKER_INFO: 'Click a shop marker on the map to view detailed information.',
    RESOLVING_LOCAL_BODY: 'Resolving Local Body...',
    FOUND: 'found',
    MISPLACED: 'misplaced',
    POTENTIAL_DATA_ERRORS: 'Potential Data Errors',
    MISPLACED_DATA_FOUND: 'Misplaced Data Found',
    GEOGRAPHICALLY_MISPLACED: 'Geographically misplaced in registry',
    AC_NUMBER: 'AC Number',
    PC_NUMBER: 'PC Number',
    STATION_NAME: 'Station Name',
    STATION_CODE: 'Station Code',
    BOUNDARY_STATUS: 'Boundary Status',
    JURISDICTION_CODE: 'Jurisdiction Code',
    STATION_OFFICER: 'Station Officer',
    PHONE: 'Phone',
    STATION_DATA_UPDATING: 'Official boundary data for this station is currently being updated.',
    FIND_POLICE_JURISDICTION: 'Find Police Jurisdiction',
    FIND_REGISTRATION_JURISDICTION: 'Find Registration Jurisdiction',
    CLICK_FIND_POLICE: 'Click your location on the map to find the responsible police station.',
    CLICK_FIND_REGISTRATION: 'Click your location on the map to find the responsible Sub Registrar Office.',
    POLICE_JURISDICTIONS: 'Police Jurisdictions',
    REGISTRATION_JURISDICTIONS: 'Registration Jurisdictions',
    SRO_ID: 'SRO Code',
    ZONE_NAME: 'Zone',
    VIEWING_SRO_AREA: 'Viewing SRO Area',
    CLICK_FIND_SRO: 'Click your location on the map to find the responsible Sub Registrar Office.',
    STATION_FIRST_DISCOVERY: 'Station-First Discovery',
    CLICK_STATION_BOUNDARY: 'Click any police station marker to view its jurisdictional boundary and details.',
    DELIVERY_SERVICES: 'Delivery Services',
    EMERGENCY_24X7: '24x7 Emergency',
    FIRST_REFERRAL_UNIT: 'First Referral Unit',
    NEWBORN_CARE: 'Newborn Care',
    DIALYSIS_CENTER: 'Dialysis Center',
    TIMING: 'Timing',
    OPEN_24_HOURS: 'Open 24 Hours',
    DAY_SERVICES: 'Day Services (General Hours)',
    GENERAL_HOURS_CONTACT: 'General Hours / Contact Facility',
    FACILITY_ID: 'Facility ID',
    HEALTH_DISCOVERY: 'Health Discovery',
    STATEWIDE_VIEW: 'Statewide View',
    SEARCH_EXPLORE_HEALTH: 'Search for a district or pincode to explore local health facilities.',
    NO_INFO_FOUND: 'No Information Found',
    DATA_UNAVAILABLE: 'Data Unavailable',
    NO_JURISDICTION_DATA: "We don't have specific jurisdictional data for this exact coordinate yet.",
    SERVER_TIMEOUT: 'Government Server Unresponsive',
    SERVER_ERROR: 'Service Temporarily Unavailable',
    TNGIS_TIMEOUT_DESC: 'The government server took too long to respond. Please try again to retry.',
    TNGIS_ERROR_DESC: 'Failed to communicate with the government service. Please try again later.',
    CONTRIBUTE_DATA: 'CONTRIBUTE DATA',
    ACCURACY_WARNING: 'Location Accuracy Warning',
    POSTAL_ACCURACY_DESC: 'This office coordinates in the official registry appear to be incorrect and have been hidden from the map for clarity.',

    // Health Summary & Guidance
    EMERGENCY_HUBS_SHOWING: 'Showing emergency hubs and referral units.',
    MATERNAL_DELIVERY_SHOWING: 'Showing facilities for maternal delivery services.',
    NEWBORN_CHILD_CARE_SHOWING: 'Showing specialized newborn and child care centres.',
    DIAGNOSTIC_CENTRES_SHOWING: 'Showing diagnostic centres (CT/MRI/Dialysis).',
    LOCAL_CENTRES_FOCUSED: 'Local Centres Focused',
    ACTION_REQUIRED: 'Action Required',
    LOCAL_CENTRES_VISIBILITY: 'Local Centres (PHC/HSC) are visible when viewing a specific District or Pincode.',
    SEARCH_DISTRICT_LOCAL: 'Search a district or use My Area to see local results.',
    TN_MAJOR_HOSPITALS: 'Tamil Nadu Major Hospitals',
    STATEWIDE_VIEW_LABEL: 'Statewide View',
    MAJOR_HOSPITALS_STATEWIDE: 'Showing major hospitals across the state.',
    SECONDARY_CARE_FACILITIES: 'Secondary Care Facilities',
    SECONDARY_CARE_STATEWIDE: 'Showing CHCs and Sub-District hospitals.',
    ALL_HEALTH_FACILITIES: 'All Health Facilities',
    ALL_FACILITIES_STATEWIDE: 'Showing all available health facilities.',
    ZOOM_IN_FOR_LOCAL: 'Zoom into a district or area to view local centres.',
    SEARCH_DISTRICT_AREA_LOCAL: 'Search a district or area to find local centres.',
    HEALTH_FACILITIES_IN: 'Health Facilities in',
    DISTRICT_VIEW_LABEL: 'District View',
    HEALTH_INFRA_DISTRICT: 'Exploring healthcare infrastructure in this district.',
    CLICK_MAP_DETAILS: 'Tap a marker to view details or filter by service.',
    LOCAL_HEALTH_SERVICES: 'Local Health Services',
    LOCAL_VIEW_LABEL: 'Local View',
    FACILITIES_NEAR_AREA: 'Viewing facilities near your selected area.',
    TAP_NAV_TIMING: 'Tap a marker to view timing and get directions.',
    FACILITIES: 'Facilities',
    CLEAR_ALL: 'Clear All',
    WANT_LOCAL_HEALTH: 'Want to see local health centres?',
    FIND_FACILITIES_NEAR_ME: 'Find Facilities Near Me',
    DELIVERY_POINTS: 'Delivery Points',
    DIALYSIS_UNITS: 'Dialysis Units',
    NETWORK_ERROR_TITLE: 'Network Connection Lost',
    NETWORK_ERROR_DESC: 'We are having trouble connecting to our data servers. Please check your internet connection.',
    RETRY: 'RETRY',

    // Health Assistant & Filters
    HEALTH_ASSISTANT: 'Health Assistant',
    TN_HEALTH_SERVICES: 'Tamil Nadu Health Services',
    HEALTH_IN: 'Health in',
    EXPLORE_LOCAL_HEALTH: 'Explore Local Health',
    CHOOSE_NEED_SEARCH: 'Choose a need or search your district / pincode to begin.',
    FACILITY_GROUPS: 'Facility Groups',
    MAJOR_HOSPITALS: 'Major Hospitals',
    SECONDARY_CARE: 'Secondary Care',
    LOCAL_CENTRES: 'Local Centres',
    SHOW_MORE_FILTERS: 'Show More Filters',
    COMMON_SERVICES: 'Common Services',
    AVAILABILITY_24X7: '24x7 Availability',
    ADVANCED_MEDICAL_FILTERS: 'Advanced Medical Filters',
    SPECIALIST_MEDICAL: 'Specialist Medical',
    WELLNESS_CENTRE: 'Wellness Centre',
    EMERGENCY_REFERRAL: 'Emergency Referral',
    BLOOD_BANK: 'Blood Bank',
    BLOOD_STORAGE: 'Blood Storage',
    CT_SCAN: 'CT Scan',
    MRI: 'MRI',
    TELE_CONSULTATION: 'Tele-Consultation',
    STEMI_HUB: 'STEMI Hub',
    STEMI_SPOKE: 'STEMI Spoke',
    CATH_LAB: 'Cath Lab',
    CHILD_SUPPORT: 'Child Support',
    CHILD_SUPPORT_SERVICES: 'Child support services',
    SPECIFIC_FACILITY_TYPES: 'Specific Facility Types',
    HIDE_EXPERT_FILTERS: 'Hide Expert Filters',
    MY_AREA: 'My Area',
    CHILD_CARE: 'Child Care',
    CBNAAT: 'CBNAAT Site',
    HIDE: 'Hide',

    // Local Bodies V2
    NAMMAMAP_UNIFIED: 'NammaMap Unified Discovery',
    DATA_SOURCE_GIS_TN: 'Data Source: GIS TN',

    // Legal Detailed
    LINKEDIN: 'LinkedIn',
    CONTACT: 'Contact',
    LOCATION_ACCESS: 'Location Access',
    CACHING: 'Caching',
    CACHING_DESC: 'GIS data is cached locally in your browser\'s IndexedDB to improve performance. This data stays on your device.',
    COOKIES: 'Cookies',
    COOKIES_DESC: 'We use minimal local storage to remember your theme preference (Dark/Light mode).',
    THIRD_PARTY_SERVICES: 'Third-Party Services',
    THIRD_PARTY_DESC: 'We use Firebase Hosting for deployment and Leaflet/CartoDB for map tiles. These services may collect standard server logs as part of their operations.',
    INTELLECTUAL_PROPERTY: 'Intellectual Property',
    IP_DESC: 'The application source code is the property of the developer. The GIS datasets remain the property of their respective departments and sources.',
    LIMITATION_LIABILITY: 'Limitation of Liability',
    LIABILITY_DESC: 'The service is provided "AS IS" without any warranties. The developer shall not be liable for any damages arising from the use or inability to use this portal.',
    BUILD_VERSION: 'Build Version',
    ACCURACY_DATA: 'Accuracy of Data',
    VERIFY_OFFICIAL: 'Users are advised to verify jurisdictional data with official government records before making any legal or administrative decisions. The developer assumes no responsibility for any inaccuracies or decisions made based on the data provided here.',

    // Search Categories & Subtitles
    CAT_POLICE: 'Police Stations',
    CAT_TNEB: 'TNEB Sections',
    CAT_PINCODE: 'Areas & Pincodes',
    CAT_DISTRICT: 'Districts',
    CAT_PDS: 'PDS Shops',
    CAT_CONSTITUENCY: 'Constituencies',
    CAT_REGISTRATION: 'Registration Offices',
    CAT_HEALTH: 'Hospitals & Health Centres',
    CAT_OTHER: 'Other',
    SUB_DISTRICT_BOUNDARY: 'District Boundary',
    SUB_PC: 'Parliamentary Constituency',
    SUB_AC: 'Assembly Constituency',
    SUB_POLICE: 'Police Station',
    SUB_REGISTRATION: 'Registration Office',
    SUB_AREA_BOUNDARY: 'Area Boundary',
    SUB_LOCAL_AREA: 'Local Area',
    HO_EXPLANATION: 'This is a main post office with full postal and banking services.',
    NON_DELIVERY_EXPLANATION: 'This post office does not deliver to homes. Visit here for counter services.',
    GO_TO_COORDINATES: 'Go to coordinates',
    CAT_COORDINATES: 'Coordinates',
    CAT_GLOBAL: 'Global Places',

    // Tutorial
    TUTORIAL_WELCOME_TITLE: 'Welcome to NammaMap V2',
    TUTORIAL_WELCOME_DESC: 'Your unified portal for discovering civic services in Tamil Nadu. Let\'s take a quick tour!',
    TUTORIAL_LAYERS_TITLE: 'Service Layers',
    TUTORIAL_LAYERS_DESC: 'Switch between different services like Post Offices, Ration Shops, Electricity Board, and Health Facilities.',
    TUTORIAL_SEARCH_TITLE: 'Smart Search',
    TUTORIAL_SEARCH_DESC: 'Search for anything—from a specific District to a street address or landmark.',
    TUTORIAL_LOCATE_TITLE: 'Locate Me',
    TUTORIAL_LOCATE_DESC: 'Instantly find services for your current location using GPS.',
    TUTORIAL_MAP_TITLE: 'Interactive Map',
    TUTORIAL_MAP_DESC: 'Tap anywhere on the map to discover which service office is responsible for that exact spot.',
    TUTORIAL_LANG_TITLE: 'Language',
    TUTORIAL_LANG_DESC: 'Switch between English and Tamil at any time.',
    TUTORIAL: 'Tutorial',
    POS_DEVICES: 'POS Devices',
    TOTAL_TRANSACTIONS: 'Total Transactions',
    BANKS: 'Banks',
    DIGITAL_PAYMENTS: 'Digital Payments',
    NO_POS_DEVICES: 'No POS devices currently linked to this temple.',
  },
  ta: {
    // Sidebar Labels
    ESSENTIALS: 'அவசியமானவை',
    CIVIC: 'குடிமை',
    SAFETY: 'பாதுகாப்பு',
    UTILITIES: 'பயன்பாடுகள்',
    SETTINGS: 'அமைப்புகள்',
    CULTURE_AND_HERITAGE: 'கலாச்சாரம் & பாரம்பரியம்',
    NAMMA_ARASU: 'நம்ம அரசு',
    MANIFESTO: 'தேர்தல் அறிக்கை',
    TRACKER: 'செயல்பாட்டு கண்காணிப்பு',
    NEWS: 'செய்திகள்',

    // Layers
    PINCODE: 'அஞ்சல் நிலையங்கள்',
    PDS: 'நியாயவிலைக் கடைகள்',
    HEALTH: 'சுகாதார மையங்கள்',
    VETERINARY: 'கால்நடை சேவைகள்',
    VET_POLY_CLINIC: 'கால்நடை பல்நோக்கு மருத்துவமனை',
    VET_CLINIC_CENTER: 'கால்நடை மருத்துவ நிபுணர் மையம்',
    VET_HOSPITAL: 'கால்நடை மருத்துவமனை',
    VET_DISPENSARY: 'கால்நடை மருந்தகம்',
    VET_SUB_CENTER: 'கால்நடை கிளை நிலையம்',
    LOCAL_BODIES_V2: 'உள்ளாட்சி அமைப்புகள்',
    CONSTITUENCY: 'தொகுதிகள்',
    POLICE: 'காவல் எல்லைகள்',
    TNEB: 'மின்சார வாரியம்',
    REGISTRATION: 'பதிவு அலுவலகங்கள்',
    LAND_PARCEL: 'புல எண் தேடல் (Survey No.)',
    TEMPLES: 'கோயில்கள் (HRCE)',
    CORPORATION: 'மாநகராட்சி',
    MUNICIPALITY: 'நகராட்சி',
    TOWN_PANCHAYAT: 'பேரூராட்சி',
    VILLAGE_PANCHAYAT: 'கிராம ஊராட்சி',
    UNKNOWN_LOCAL_BODY: 'உள்ளாட்சி அமைப்பு',
    VET_INSTITUTION: 'கால்நடை மருத்துவ நிலையம்',
    ABOUT_APP: 'விவரங்கள்',
    LEGAL_PRIVACY: 'சட்டவிதிகள்',
    DISCLAIMER: 'பொறுப்புத்துறப்பு',
    ATTRIBUTIONS: 'அங்கீகாரம்',
    SOFTWARE_LIBRARIES: 'மென்பொருள் நூலகங்கள்',
    MAP_INFRASTRUCTURE: 'வரைபட கட்டமைப்பு',
    DATA_SOURCES_CREDITS: 'தரவு ஆதாரங்கள் & அங்கீகாரம்',
    POWERED_BY: 'இயக்குவது',
    DEVELOPED_USING: 'உருவாக்கப்பட்டது',
    CORE_FRAMEWORKS: 'முக்கிய கட்டமைப்புகள்',
    GIS_ENGINE: 'GIS & தர்க்க இயந்திரம்',
    UI_UX_DESIGN: 'UI/UX & கூறுகள்',
    BACKEND_SERVICES: 'பின்புல சேவைகள்',
    GOVT_DATA_PORTALS: 'அரசு தரவு இணையதளங்கள்',

    // Singular sharing labels
    RATION_SHOP: 'ரேஷன் கடை',
    HEALTH_FACILITY: 'சுகாதார மையம்',
    VETERINARY_FACILITY: 'கால்நடை மருத்துவமனை',
    POLICE_STATION: 'காவல் நிலையம்',
    SRO: 'சார்பதிவாளர் அலுவலகம்',
    CONSTITUENCY_SINGLE: 'தொகுதி',
    LAND_DETAILS: 'நில விவரங்கள்',
    TEMPLE_FACILITY: 'திருக்கோயில்',
    CAT_TEMPLES: 'திருக்கோயில்கள் (HRCE)',
    CAT_FUEL: 'எரிபொருள் நிலையங்கள்',
    DEEP_LINK_HINT: 'இந்த எல்லைக்குள் உங்கள் இடத்தைத் தொடவும்',
    SEARCHED_LOCATION: 'தேடப்பட்ட இடம்',

    // Election Strings
    ELECTION_LIVE: 'தேர்தல் முடிவுகள் 2026',
    ELECTION_PROVISIONAL_BANNER: 'முடிவுகள் தற்காலிகமானவை மற்றும் ECI புதுப்பிப்புகளுக்கு உட்பட்டவை.',
    LAST_UPDATED: 'கடைசியாக புதுப்பிக்கப்பட்டது',
    LEADING: 'முன்னிலை',
    WON: 'வெற்றி',
    TALLY_PROGRESS: 'அறிக்கையிடப்படுகிறது',
    CONSTITUENCIES_COUNT: 'தொகுதிகள்',
    TOTAL_SEATS: 'மொத்த இடங்கள்',
    LEADS_BY_PARTY: 'கட்சி வாரியாக நிலை',
    PARTY_DMK: 'திமுக',
    PARTY_ADMK: 'அதிமுக',
    PARTY_TVK: 'தவெக',
    PARTY_CPI: 'சிபிஐ',
    PARTY_BJP: 'பாஜக',
    PARTY_INC: 'காங்கிரஸ்',
    PARTY_NTK: 'நாதக',
    PARTY_PMK: 'பாமக',
    PARTY_VCK: 'விசிக',
    PARTY_OTHERS: 'மற்றவை',
    PARTY_NA: 'முடிவுகளுக்காக காத்திருக்கிறது',

    // UI Elements
    ABOUT_LEGAL: 'விவரங்கள் & சட்டவிதிகள்',
    DARK_MODE: 'இருண்ட பயன்முறை',
    LIGHT_MODE: 'ஒளி பயன்முறை',
    LOCATING: 'கண்டறியப்படுகிறது...',
    LOCATE_ME: 'உங்கள் இருப்பிடம் கண்டறியப்படுகிறது...',
    LOCATING_SUBTEXT: 'உள்ளூர் சேவை விவரங்களை வழங்க உங்கள் சரியான பகுதியைக் கண்டறியவும்.',
    GPS_ACTIVE: 'GPS செயலில் உள்ளது',
    SEARCH_PLACEHOLDER: 'பகுதி, பின்கோடு அல்லது அலுவலகத்தைத் தேடுங்கள்...',
    EXPERIMENTAL: 'BETA',
    EXPERIMENTAL_TAG: 'EXPERIMENTAL',

    // Actions
    DIRECTIONS: 'வழிசெலுத்தல்',
    REPORT_ISSUE: 'பிழையைத் தெரிவி',
    CLOSE: 'மூடு',
    CANCEL: 'ரத்து செய்',
    SEND: 'அனுப்பு',
    COPY: 'நகலெடு',
    VIEW_DETAILS: 'விவரங்களைக் காண்க',
    YES: 'ஆம்',
    NO: 'இல்லை',
    LATER: 'பிறகு செய்',

    // Administrative Labels
    DISTRICT: 'மாவட்டம்',
    TALUK: 'தாலுகா',
    BLOCK: 'ஒன்றியம்',
    WARD: 'வார்டு',
    ZONE: 'மண்டலம்',
    VILLAGE: 'கிராமம்',
    CATEGORY: 'வகை',
    DIVISION: 'கோட்டம்',
    CIRCLE: 'வட்டம்',
    REGION: 'மண்டலம்',
    STATE: 'மாநிலம்',
    AREA: 'பகுதி',
    JURISDICTION: 'எல்லை',
    PIN_CODE: 'அஞ்சல் குறியீடு',
    SURVEY_NUMBER: 'புல எண் (Survey No)',
    SUB_DIVISION: 'உட்பிரிவு (Subdivision)',
    ULPIN: 'யு.எல்.பி.ஐ.என் (ULPIN)',
    REVENUE_VILLAGE: 'வருவாய் கிராமம்',
    OFFICE_TYPE: 'அலுவலக வகை',
    ABOUT_OFFICE: 'அலுவலகம் பற்றி',
    MORE_INFO: 'கூடுதல் விவரங்கள்',
    SHOP_CODE: 'கடை குறியீடு',
    INCHARGE: 'பொறுப்பாளர்',
    CARE_LEVEL: 'பராமரிப்பு நிலை',
    LOCAL_OFFICES: 'உள்ளூர் அலுவலகங்கள்',
    LOCATION: 'இடம்',
    LOCATIONS: 'இடங்கள்',
    COORDINATES: 'ஆயத்தொலைவுகள் (Coordinates)',
    SURVEY_PARCEL: 'புல எண் (Survey Parcel)',
    APPROX_AREA: 'தோராயமான பரப்பு',
    REVENUE_WARD: 'வருவாய் வார்டு',
    REVENUE_BLOCK: 'வருவாய் பிளாக்',
    OUTSIDE_TN: 'இந்த இடம் தமிழ்நாட்டிற்கு வெளியே உள்ளது. தயவுசெய்து மாநிலத்திற்குள் உள்ள இடத்தைத் தேர்ந்தெடுக்கவும்.',

    // Postal Specific Values
    HO: 'தலைமை அஞ்சலகம்',
    SO: 'துணை அஞ்சலகம்',
    BO: 'கிளை அஞ்சலகம்',
    PO: 'அஞ்சல் அலுவலகம்',
    DELIVERY: 'விநியோக அலுவலகம்',
    NON_DELIVERY: 'விநியோகம் இல்லாத அலுவலகம்',
    POSTAL_DESC_DELIVERY: 'இந்த அஞ்சல் அலுவலகம் அருகிலுள்ள வீடுகளுக்கு கடிதங்கள் மற்றும் பார்சல்களை விநியோகம் செய்கிறது.',
    POSTAL_DESC_NON_DELIVERY: 'இந்த அலுவலகம் கவுண்டர் சேவைகளை வழங்குகிறது, ஆனால் கடிதங்களை நேரடியாக விநியோகம் செய்யாது.',

    // Facility Types
    MCH: 'மருத்துவக் கல்லூரி மருத்துவமனை',
    DH: 'மாவட்ட மருத்துவமனை',
    SDH: 'தாலுகா மருத்துவமனை',
    CHC: 'சமூக சுகாதார மையம்',
    PHC: 'ஆரம்ப சுகாதார மையம்',
    HSC: 'சுகாதார துணை மையம்',

    // Status & Instructions
    STATUS: 'நிலை',
    VERIFIED: 'சரிபார்க்கப்பட்டது',
    UNAVAILABLE: 'கிடைக்கவில்லை',
    INSTRUCTION: 'அறிவுறுத்தல்',
    NEXT_STEP: 'அடுத்த கட்டம்',
    MESSAGE: 'செய்தி',
    NOTE: 'குறிப்பு',
    REASON: 'காரணம்',
    HIGHLIGHTS: 'சிறப்பம்சங்கள்',
    ACTIVE_FILTERS: 'செயலில் உள்ள வடிகட்டிகள்',
    TIP: 'குறிப்பு',

    // Health/Postal Filters
    EMERGENCY: 'அவசர நிலை',
    DELIVERY_SERVICE: 'விநியோகம்',
    DIAGNOSTICS: 'கண்டறிதல்',
    STATEWIDE: 'மாநிலம் தழுவிய',

    // Modals & Legal
    PRIVACY: 'தனியுரிமை',
    TERMS: 'விதிமுறைகள்',
    DEVELOPER_INFO: 'உருவாக்கியவர் விவரம்',
    CORRECTION_DETAILS: 'திருத்த விவரங்கள்',
    TECHNICAL_DETAILS: 'தொழில்நுட்ப விவரங்கள்',
    UPDATING: 'புதுப்பிக்கப்படுகிறது...',

    // Legal & About Content
    NON_GOVT_TITLE: 'அரசு சாரா அமைப்பு',
    NON_GOVT_DESC: 'நம்ம மேப் (NammaMap) என்பது ஒரு சுதந்திரமான, வணிக நோக்கமற்ற ஆராய்ச்சி திட்டமாகும். இது தமிழ்நாடு அரசு, இந்திய அரசு அல்லது அவற்றின் எந்தவொரு முகமைகளுடனும் அதிகாரப்பூர்வமாக இணைக்கப்படவில்லை.',
    DATA_SOURCE_DESC: 'இந்தத் தளத்தில் காட்டப்படும் அனைத்துத் தரவுகளும் பொதுவில் கிடைக்கக்கூடிய அரசுத் தரவுத்தொகுப்புகள் மற்றும் பொதுப் பதிவுகளிலிருந்து சேகரிக்கப்பட்டவை. துல்லியத்திற்காக நாங்கள் முயற்சி செய்தாலும், எல்லைகள் மற்றும் இடங்கள் தகவல் நோக்கங்களுக்காக மட்டுமே பயன்படுத்தப்பட வேண்டும்.',

    ELECTION_DATA_TITLE: 'தேர்தல் புள்ளிவிவரங்கள்',
    ELECTION_DATA_DESC: 'தேர்தல் முடிவுகள், வேட்பாளர்கள் மற்றும் வாக்கு எண்ணிக்கை சுருக்கங்கள் ஆய்வு நோக்கங்களுக்காக மட்டுமே. அதிகாரப்பூர்வ அறிவிப்புகள் தேர்தல் ஆணையங்கள் வழியாக உறுதிப்படுத்தப்பட வேண்டும்.',
    ZERO_DATA_TITLE: 'பூஜ்ஜியத் தரவுக் கொள்கை',
    ZERO_DATA_DESC: 'நம்ம மேப் உங்கள் தனியுரிமையை மதிக்கிறது. நாங்கள் தனிப்பட்ட முறையில் அடையாளம் காணக்கூடிய எந்தத் தகவலையும் சேகரிக்கவோ, சேமிக்கவோ அல்லது விற்கவோ மாட்டோம்.',
    LOCATION_PRIVACY: '"என்னைத் தேடு" அம்சத்தைப் பயன்படுத்தும்போது, உங்கள் இருப்பிடம் உங்கள் உலாவியிலேயே செயல்படுத்தப்படுகிறது. உங்கள் இருப்பிட வரலாற்றை நாங்கள் ஒருபோதும் சேமிப்பதில்லை.',
    ACCEPTABLE_USE_TITLE: 'ஏற்கத்தக்க பயன்பாடு',
    ACCEPTABLE_USE_DESC: 'நம்ம மேப்-ஐப் பயன்படுத்துவதன் மூலம், சேவையைச் சட்டப்பூர்வ நோக்கங்களுக்காகப் பயன்படுத்த ஒப்புக்கொள்கிறீர்கள். பயன்பாட்டின் உள்கட்டமைப்பை சீர்குலைக்க நீங்கள் முயற்சிக்கக்கூடாது.',
    UNDERSTAND: 'எனக்கு புரிகிறது',
    INDICATIVE_DATA_DISCLAIMER: 'TNGIS-லிருந்து பெறப்பட்ட தோராயமான நிலத் தகவல்',

    // New General UI
    SKIP_TO_RESULTS: 'முடிவுகளுக்குச் செல்லவும்',
    SEARCH_FOR_LOCATION: 'இடத்தைத் தேடுங்கள்',
    CLEAR_SEARCH: 'தேடலை நீக்குக',
    LOCATE_ME_ARIA: 'என்னைத் தேடு',
    CLOSE_SIDEBAR: 'பக்கவாட்டுப் பட்டியை மூடவும்',
    OPEN_SIDEBAR: 'பக்கவாட்டுப் பட்டியைத் திறக்கவும்',
    SWITCH_TO_TAMIL: 'தமிழுக்கு மாறவும்',
    SWITCH_TO_ENGLISH: 'ஆங்கிலத்திற்கு மாறவும்',
    SWITCH_TO_LIGHT_MODE: 'ஒளி பயன்முறைக்கு மாறவும்',
    SWITCH_TO_DARK_MODE: 'இருண்ட பயன்முறைக்கு மாறவும்',
    INDEPENDENT_PORTAL: 'சுதந்திரமான தமிழ்நாடு GIS தளம்',
    ASSEMBLY: 'சட்டமன்றம்',
    PARLIAMENT: 'நாடாளுமன்றம்',
    HEALTH_EXPERIMENTAL_DESC: 'சுகாதார வசதிகளைக் கண்டறியும் முறையை நாங்கள் இன்னும் மேம்படுத்தி வருகிறோம்.',
    OR: 'அல்லது',
    SERVICE_LAYERS_ARIA: 'சேவை அடுக்குகள்',
    CLICK_FIND_TNEB: 'உங்கள் TNEB பிரிவு அலுவலகத்தைக் கண்டறிய வரைபடத்தில் உங்கள் இருப்பிடத்தைக் கிளிக் செய்யவும்.',
    FIND_TNEB_SECTION: 'TNEB பிரிவைக் கண்டறியவும்',
    TN: 'தமிழ்நாடு',

    // Result Card & Accuracy
    ACCURACY: 'துல்லியம்',
    VICINITY_DISCLAIMER: 'தோராயமான இடம். 200 மீட்டருக்குள் அலுவலகம் அமைந்துள்ளது.',
    MATCH_CONFIDENCE: 'பொருத்தம் உறுதி',
    CONFIDENCE_HIGH: 'அதிகம் (சரிபார்க்கப்பட்ட அதிகார வரம்பு)',
    CONFIDENCE_MEDIUM: 'நடுத்தரம் (மாநிலம் தழுவிய நேரடிப் பொருத்தம்)',
    CONFIDENCE_LOW: 'குறைவு (பெயர் அடிப்படையிலான உத்தேசப் பொருத்தம்)',
    GET_DIRECTIONS_FOR: '{{title}} க்கான வழிகளைப் பெறுங்கள்',
    SHARE_CARD_FOR: '{{title}} க்கான கார்டைப் பகிரவும்',
    MINIMIZE_CARD: 'கார்டைச் சிறிதாக்கு',
    ZOOM_TO_PARCEL: 'நிலப்பகுதிக்குச் செல்ல',
    CLEAR_SELECTION: 'தேர்வை நீக்குக',
    COPY_SURVEY: 'புல எண்ணை நகலெடு',
    SHARE_PARCEL: 'பகிரவும்',
    COPY_LABEL: '{{label}} நகலெடு',
    SEARCH_RESULTS: 'தேடல் முடிவுகள்',

    // Updates
    UPDATE_AVAILABLE: 'புதிய பதிப்பு கிடைக்கிறது',
    UPDATE_PREPARING: 'தயவுசெய்து காத்திருக்கவும்.',
    UPDATE_READY: 'மேம்படுத்தப்பட்ட புதிய பதிப்பு தயாராக உள்ளது.',
    REFRESH_NOW: 'புதுப்பிக்கவும்',
    VIEW_RESULTS: 'முடிவுகளைக் காண்க',
    TOTAL_VISITS: 'மொத்த பார்வையாளர்கள்',
    TODAY_VISITS: 'இன்றைய வருகைகள்',
    MINIMIZE: 'சிறிதாக்கு',
    EXPAND_FILTERS: 'வடிப்பான்களை விரிவுபடுத்து',
    MINIMIZE_FILTERS: 'வடிப்பான்களைச் சிறிதாக்கு',

    // Map Specific
    CLICK_TO_VIEW_JURISDICTION: 'எல்லையைப் பார்க்க கிளிக் செய்யவும்',
    SECTION_OFFICE: 'பிரிவு அலுவலகம்',
    MOBILE: 'கைபேசி',
    EMAIL: 'மின்னஞ்சல்',
    LOADING_HEALTH: 'சுகாதார மையங்கள் ஏற்றப்படுகின்றன...',
    MAP_HIERARCHY: 'வரைபட வரிசைமுறை',
    MAJOR: 'முக்கியமான',
    LOCAL: 'உள்ளூர்',
    SUB_CENTRE: 'துணை மையம்',
    LOC_RETRIEVE_ERROR: 'உங்கள் இருப்பிடத்தைப் பெற முடியவில்லை. உங்கள் உலாவி அனுமதிகளைச் சரிபார்க்கவும்.',
    LOC_NOT_SUPPORTED: 'உங்கள் உலாவியில் புவிஇருப்பிட வசதி இல்லை.',
    LOC_PERM_DENIED: 'இருப்பிட அணுகல் தடுக்கப்பட்டுள்ளது. தயவுசெய்து உங்கள் உலாவி அமைப்புகளில் (முகவரிப் பட்டியில் உள்ள பூட்டு ஐகானைக் கிளிக் செய்யவும்) அதை அனுமதித்து மீண்டும் முயற்சிக்கவும்.',

    // Health Area Prompt
    FOCUS_AREA_REQUIRED: 'கவனம் செலுத்த வேண்டிய பகுதி தேவை',
    FOCUS_AREA_DESC: 'உள்ளூர் சுகாதார நிலையங்களைக் (PHC/HSC) காட்ட, தயவுசெய்து ஒரு குறிப்பிட்ட பகுதி அல்லது மாவட்டத்தைத் தேர்ந்தெடுக்கவும்.',
    USE_MY_LOCATION: 'எனது தற்போதைய இருப்பிடத்தைப் பயன்படுத்து',
    USE_SEARCH_BAR: 'மேலே உள்ள தேடல் பட்டியைப் பயன்படுத்தவும்',
    SEARCH_UNLOCK_DESC: 'உள்ளூர் வசதிகளைக் கண்டறிய பின்கோடு, ஒன்றியம் அல்லது மாவட்டத்தின் பெயரை உள்ளிடவும்.',

    // Result Container & Instructions
    PDS_SHOPS_IN: 'ரேஷன் கடைகள்',
    DISPLAYING_LOCAL_SHOPS: 'அனைத்து உள்ளூர் கடைகளும் காண்பிக்கப்படுகின்றன',
    CLICK_MARKER_INFO: 'விரிவான தகவல்களைக் காண வரைபடத்தில் உள்ள கடை அடையாளட்டியைக் கிளிக் செய்யவும்.',
    RESOLVING_LOCAL_BODY: 'உள்ளூர் அமைப்பு கண்டறியப்படுகிறது...',
    FOUND: 'கண்டறியப்பட்டது',
    MISPLACED: 'தவறாக உள்ளது',
    POTENTIAL_DATA_ERRORS: 'தரவுப் பிழைகள் இருக்கலாம்',
    MISPLACED_DATA_FOUND: 'தவறான இடத் தரவு கண்டறியப்பட்டது',
    GEOGRAPHICALLY_MISPLACED: 'பதிவேட்டில் புவியியல் ரீதியாக தவறாக உள்ளது',
    AC_NUMBER: 'சட்டமன்றத் தொகுதி எண்',
    PC_NUMBER: 'நாடாளுமன்றத் தொகுதி எண்',
    STATION_NAME: 'நிலையப் பெயர்',
    STATION_CODE: 'நிலையக் குறியீடு',
    BOUNDARY_STATUS: 'எல்லை நிலை',
    JURISDICTION_CODE: 'அதிகார வரம்பு குறியீடு',
    STATION_OFFICER: 'நிலைய அதிகாரி',
    PHONE: 'தொலைபேசி',
    STATION_DATA_UPDATING: 'இந்த நிலையத்திற்கான அதிகாரப்பூர்வ எல்லைத் தரவு தற்போது புதுப்பிக்கப்பட்டு வருகிறது.',
    FIND_POLICE_JURISDICTION: 'காவல் எல்லைப் பகுதியைக் கண்டறியவும்',
    FIND_REGISTRATION_JURISDICTION: 'பதிவு அதிகார வரம்பைக் கண்டறியவும்',
    CLICK_FIND_POLICE: 'பொறுப்பான காவல் நிலையத்தைக் கண்டறிய வரைபடத்தில் உங்கள் இருப்பிடத்தைக் கிளிக் செய்யவும்.',
    CLICK_FIND_REGISTRATION: 'உங்களுக்குப் பொறுப்பான சார்பதிவாளர் அலுவலகத்தைக் கண்டறிய வரைபடத்தில் உங்கள் இருப்பிடத்தைக் கிளிக் செய்யவும்.',
    POLICE_JURISDICTIONS: 'காவல் எல்லைகள்',
    REGISTRATION_JURISDICTIONS: 'பதிவு எல்லைகள்',
    SRO_ID: 'சார் பதிவாளர் குறியீடு',
    ZONE_NAME: 'மண்டலம்',
    VIEWING_SRO_AREA: 'சார் பதிவாளர் பகுதியைப் பார்க்கிறோம்',
    CLICK_FIND_SRO: 'பொறுப்பான சார் பதிவாளர் அலுவலகத்தைக் கண்டறிய வரைபடத்தில் கிளிக் செய்யவும்.',
    STATION_FIRST_DISCOVERY: 'முதலில் நிலையத் தேடல்',
    CLICK_STATION_BOUNDARY: 'எந்தவொரு காவல் நிலைய அடையாளட்டியையும் கிளிக் செய்வதன் மூலம் அதன் அதிகார வரம்பு மற்றும் விவரங்களைக் காணலாம்.',
    DELIVERY_SERVICES: 'பிரசவ சேவைகள்',
    EMERGENCY_24X7: '24x7 அவசர சிகிச்சை',
    FIRST_REFERRAL_UNIT: 'முதல் நிலை பரிந்துரை மையம்',
    NEWBORN_CARE: 'பச்சிளம் குழந்தை பராமரிப்பு',
    DIALYSIS_CENTER: 'டயாலிசிஸ் மையம்',
    TIMING: 'நேரம்',
    OPEN_24_HOURS: '24 மணிநேரமும் திறந்திருக்கும்',
    DAY_SERVICES: 'பகல் நேர சேவைகள் (பொது நேரம்)',
    GENERAL_HOURS_CONTACT: 'பொது நேரம் / வசதியைத் தொடர்பு கொள்ளவும்',
    FACILITY_ID: 'வசதி அடையாள எண்',
    HEALTH_DISCOVERY: 'சுகாதாரத் தேடல்',
    STATEWIDE_VIEW: 'மாநில அளவிலான பார்வை',
    SEARCH_EXPLORE_HEALTH: 'உள்ளூர் சுகாதார வசதிகளை ஆராய மாவட்டத்தை அல்லது பின்கோட்டைத் தேடுங்கள்.',
    NO_INFO_FOUND: 'தகவல் எதுவும் இல்லை',
    DATA_UNAVAILABLE: 'தகவல் இல்லை',
    NO_JURISDICTION_DATA: 'இந்த இடத்திற்கான குறிப்பிட்ட எல்லைத் தரவு இன்னும் எங்களிடம் இல்லை.',
    SERVER_TIMEOUT: 'அரசு சேவையகம் பதிலளிக்கவில்லை',
    SERVER_ERROR: 'சேவை தற்காலிகமாக கிடைக்கவில்லை',
    TNGIS_TIMEOUT_DESC: 'அரசு சேவையகம் பதிலளிக்க அதிக நேரம் எடுத்துக்கொண்டது. மீண்டும் முயற்சிக்க இந்த இடத்தை மீண்டும் கிளிக் செய்யவும்.',
    TNGIS_ERROR_DESC: 'அரசு சேவையுடன் தொடர்புகொள்ள முடியவில்லை. தயவுசெய்து சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.',
    CONTRIBUTE_DATA: 'தகவலைப் பங்களிக்கவும்',
    ACCURACY_WARNING: 'இருப்பிட துல்லியம் எச்சரிக்கை',
    POSTAL_ACCURACY_DESC: 'அதிகாரப்பூர்வ பதிவேட்டில் உள்ள இந்த அலுவலக ஒருங்கிணைப்புகள் தவறாகத் தோன்றுகின்றன, எனவே வரைபடத்திலிருந்து மறைக்கப்பட்டுள்ளன.',

    // Health Summary & Guidance
    EMERGENCY_HUBS_SHOWING: 'அவசர சிகிச்சை மையங்கள் காட்டப்படுகின்றன.',
    MATERNAL_DELIVERY_SHOWING: 'மகப்பேறு சிகிச்சை மையங்கள் காட்டப்படுகின்றன.',
    NEWBORN_CHILD_CARE_SHOWING: 'குழந்தை நல சிகிச்சை மையங்கள் காட்டப்படுகின்றன.',
    DIAGNOSTIC_CENTRES_SHOWING: 'கண்டறியும் மையங்கள் (CT/MRI) காட்டப்படுகின்றன.',
    LOCAL_CENTRES_FOCUSED: 'உள்ளூர் மையங்கள்',
    ACTION_REQUIRED: 'நடவடிக்கை தேவை',
    LOCAL_CENTRES_VISIBILITY: 'குறிப்பிட்ட மாவட்டம் அல்லது பின்கோட்டைத் தேடும்போது மட்டுமே உள்ளூர் மையங்கள் (PHC) தெரியும்.',
    SEARCH_DISTRICT_LOCAL: 'உள்ளூர் முடிவுகளைக் காண மாவட்டத்தைத் தேடுங்கள்.',
    TN_MAJOR_HOSPITALS: 'தமிழ்நாடு முக்கிய மருத்துவமனைகள்',
    STATEWIDE_VIEW_LABEL: 'மாநிலம் தழுவிய பார்வை',
    MAJOR_HOSPITALS_STATEWIDE: 'மாநிலம் முழுவதுமுள்ள முக்கிய மருத்துவமனைகளைக் காட்டுகிறது.',
    SECONDARY_CARE_FACILITIES: 'இரண்டாம் நிலை சிகிச்சை நிலையங்கள்',
    SECONDARY_CARE_STATEWIDE: 'CHC மற்றும் தாலுகா மருத்துவமனைகளைக் காட்டுகிறது.',
    ALL_HEALTH_FACILITIES: 'அனைத்து சுகாதார மையங்கள்',
    ALL_FACILITIES_STATEWIDE: 'அனைத்து சுகாதார மையங்களையும் காட்டுகிறது.',
    ZOOM_IN_FOR_LOCAL: 'உள்ளூர் மையங்களைக் காண மாவட்டம் அல்லது பகுதியைத் தேடுங்கள்.',
    SEARCH_DISTRICT_AREA_LOCAL: 'உள்ளூர் மையங்களைக் கண்டறிய ஒரு மாவட்டம் அல்லது பகுதியைத் தேடுங்கள்.',
    HEALTH_FACILITIES_IN: 'சுகாதார மையங்கள்',
    DISTRICT_VIEW_LABEL: 'மாவட்ட பார்வை',
    HEALTH_INFRA_DISTRICT: 'இந்த மாவட்டத்தில் உள்ள சுகாதார கட்டமைப்புகள்.',
    CLICK_MAP_DETAILS: 'விவரங்களைக் காண வரைபடத்தில் கிளிக் செய்யவும்.',
    LOCAL_HEALTH_SERVICES: 'உள்ளூர் சுகாதார சேவைகள்',
    LOCAL_VIEW_LABEL: 'உள்ளூர் பார்வை',
    FACILITIES_NEAR_AREA: 'உங்கள் பகுதிக்கு அருகில் உள்ள மையங்கள்.',
    TAP_NAV_TIMING: 'வழிசெலுத்தல் மற்றும் நேரத்தை அறிய கிளிக் செய்யவும்.',
    FACILITIES: 'மையங்கள்',
    CLEAR_ALL: 'அனைத்தையும் நீக்கு',
    WANT_LOCAL_HEALTH: 'உள்ளூர் சுகாதார மையங்களைக் காண வேண்டுமா?',
    FIND_FACILITIES_NEAR_ME: 'எனக்கு அருகிலுள்ள வசதிகளைக் கண்டறியவும்',
    DELIVERY_POINTS: 'மகப்பேறு மையங்கள்',
    DIALYSIS_UNITS: 'டயாலிசிஸ் அலகுகள்',
    NETWORK_ERROR_TITLE: 'இணைய இணைப்பு துண்டிக்கப்பட்டது',
    NETWORK_ERROR_DESC: 'எங்கள் தரவு சேவையகங்களுடன் இணைப்பதில் சிக்கல் உள்ளது. உங்கள் இணைய இணைப்பைச் சரிபார்க்கவும்.',
    RETRY: 'மீண்டும் முயற்சி செய்',
    HIDE: 'மறை',
    COMMUNITY_VERIFICATION: 'சமூக சரிபார்ப்பு',
    VERIFY_NOW: 'இந்த தகவல் சரியா?',
    VERIFIED_BY: '{{count}} பேரால் சரிபார்க்கப்பட்டது',
    THANK_YOU_VERIFY: 'சரிபார்த்தமைக்கு நன்றி!',
    YES_CORRECT: 'ஆம், சரி',
    NO_INCORRECT: 'இல்லை, தவறு',
    THANKS_REPORTING: 'தகவலுக்கு நன்றி!',
    SENDING: 'அனுப்பப்படுகிறது...',
    SENT: 'அனுப்பப்பட்டது!',

    // Health Assistant & Filters
    HEALTH_ASSISTANT: 'சுகாதார உதவியாளர்',
    TN_HEALTH_SERVICES: 'தமிழ்நாடு சுகாதார சேவைகள்',
    HEALTH_IN: 'சுகாதாரம்',
    EXPLORE_LOCAL_HEALTH: 'உள்ளூர் சுகாதாரத்தை ஆராயுங்கள்',
    CHOOSE_NEED_SEARCH: 'தொடங்குவதற்கு ஒரு தேவையைத் தேர்ந்தெடுக்கவும் அல்லது மாவட்டம் / பின்கோட்டைத் தேடவும்.',
    FACILITY_GROUPS: 'வசதி குழுக்கள்',
    MAJOR_HOSPITALS: 'முக்கிய மருத்துவமனைகள்',
    SECONDARY_CARE: 'இரண்டாம் நிலை பராமரிப்பு',
    LOCAL_CENTRES: 'உள்ளூர் மையங்கள்',
    SHOW_MORE_FILTERS: 'கூடுதல் வடிப்பான்களைக் காட்டு',
    COMMON_SERVICES: 'பொதுவான சேவைகள்',
    AVAILABILITY_24X7: '24x7 கிடைக்கும் தன்மை',
    ADVANCED_MEDICAL_FILTERS: 'மேம்பட்ட மருத்துவ வடிப்பான்கள்',
    SPECIALIST_MEDICAL: 'சிறப்பு மருத்துவம்',
    WELLNESS_CENTRE: 'நல மையம்',
    EMERGENCY_REFERRAL: 'அவசர பரிந்துரை',
    BLOOD_BANK: 'இரத்த வங்கி',
    BLOOD_STORAGE: 'இரத்த சேமிப்பு',
    CT_SCAN: 'CT ஸ்கேன்',
    MRI: 'MRI',
    TELE_CONSULTATION: 'தொலைதூர ஆலோசனை',
    STEMI_HUB: 'STEMI மையம்',
    STEMI_SPOKE: 'STEMI ஸ்போக்',
    CATH_LAB: 'கேத் லேப்',
    CHILD_SUPPORT: 'குழந்தை ஆதரவு',
    CHILD_SUPPORT_SERVICES: 'குழந்தை ஆதரவு சேவைகள்',
    SPECIFIC_FACILITY_TYPES: 'குறிப்பிட்ட வசதி வகைகள்',
    HIDE_EXPERT_FILTERS: 'நிபுணர் வடிப்பான்களை மறை',
    MY_AREA: 'என் பகுதி',
    CHILD_CARE: 'குழந்தை நலம்',
    CBNAAT: 'CBNAAT தளம்',

    // Local Bodies V2
    NAMMAMAP_UNIFIED: 'நம்ம மேப் ஒருங்கிணைந்த தேடல்',
    DATA_SOURCE_GIS_TN: 'தரவு ஆதாரம்: GIS TN',

    // Legal Detailed
    LINKEDIN: 'LinkedIn',
    CONTACT: 'தொடர்பு',
    LOCATION_ACCESS: 'இருப்பிட அணுகல்',
    CACHING: 'கேச்சிங் (Caching)',
    CACHING_DESC: 'செயல்திறனை மேம்படுத்த GIS தரவு உங்கள் உலாவியின் IndexedDB இல் உள்ளூர் சேமிக்கப்படும். இந்த தரவு உங்கள் சாதனத்திலேயே இருக்கும்.',
    COOKIES: 'குக்கீகள் (Cookies)',
    COOKIES_DESC: 'உங்கள் தீம் விருப்பத்தை (இருண்ட/ஒளி பயன்முறை) நினைவில் கொள்ள நாங்கள் குறைந்தபட்ச உள்ளூர் சேமிப்பகத்தைப் பயன்படுத்துகிறோம்.',
    THIRD_PARTY_SERVICES: 'மூன்றாம் தரப்பு சேவைகள்',
    THIRD_PARTY_DESC: 'நாங்கள் கிளவுட் ஹோஸ்டிங்கிற்கு Firebase-ஐயும், வரைபடத் தகடுகளுக்கு Leaflet/CartoDB-ஐயும் பயன்படுத்துகிறோம். இந்தச் சேவைகள் தங்கள் செயல்பாடுகளின் ஒரு பகுதியாகத் தரமான சர்வர் லாக்குகளைச் சேகரிக்கலாம்.',
    INTELLECTUAL_PROPERTY: 'அறிவுசார் சொத்துரிமை',
    IP_DESC: 'பயன்பாட்டின் மூல குறியீடு டெவலப்பரின் சொத்து. GIS தரவுத்தொகுப்புகள் அந்தந்த துறைகள் மற்றும் ஆதாரங்களின் சொத்தாகவே இருக்கும்.',
    LIMITATION_LIABILITY: 'பொறுப்பு வரம்பு',
    LIABILITY_DESC: 'இந்தச் சேவை எந்தவித உத்தரவாதமும் இன்றி "உள்ளவாறு" வழங்கப்படுகிறது. இந்தத் தளத்தைப் பயன்படுத்துவதால் அல்லது பயன்படுத்த முடியாமையால் ஏற்படும் எந்தவொரு பாதிப்புகளுக்கும் டெவலப்பர் பொறுப்பேற்க மாட்டார்.',
    BUILD_VERSION: 'பதிப்பு எண்',
    ACCURACY_DATA: 'தரவின் துல்லியம்',
    VERIFY_OFFICIAL: 'பயனர்கள் எந்தவொரு சட்ட அல்லது நிர்வாக முடிவுகளையும் எடுப்பதற்கு முன் அதிகாரப்பூர்வ அரசு பதிவுகளுடன் எல்லைத் தரவைச் சரிபார்க்க அறிவுறுத்தப்படுகிறார்கள். இங்கு வழங்கப்பட்ட தரவுகளின் அடிப்படையில் எடுக்கப்படும் முடிவுகளுக்கோ அல்லது ஏதேனும் தவறுகளுக்கோ டெவலப்பர் பொறுப்பேற்க மாட்டார்.',

    // Search Categories & Subtitles
    CAT_POLICE: 'காவல் நிலையங்கள்',
    CAT_TNEB: 'TNEB பிரிவுகள்',
    CAT_PINCODE: 'பகுதிகள் & பின்கோட்கள்',
    CAT_DISTRICT: 'மாவட்டங்கள்',
    CAT_PDS: 'ரேஷன் கடைகள்',
    CAT_CONSTITUENCY: 'தொகுதிகள்',
    CAT_REGISTRATION: 'பதிவு அலுவலகங்கள்',
    CAT_HEALTH: 'மருத்துவமனைகள் & சுகாதார மையங்கள்',
    CAT_OTHER: 'மற்றவை',
    SUB_DISTRICT_BOUNDARY: 'மாவட்ட எல்லை',
    SUB_PC: 'நாடாளுமன்றத் தொகுதி',
    SUB_AC: 'சட்டமன்றத் தொகுதி',
    SUB_POLICE: 'காவல் நிலையம்',
    SUB_REGISTRATION: 'பதிவு அலுவலகம்',
    SUB_AREA_BOUNDARY: 'பகுதி எல்லை',
    SUB_LOCAL_AREA: 'உள்ளூர் பகுதி',
    HO_EXPLANATION: 'இது முழுமையான அஞ்சல் and வங்கிச் சேவைகளைக் கொண்ட தலைமை அஞ்சல் அலுவலகமாகும்.',
    NON_DELIVERY_EXPLANATION: 'இந்த அஞ்சல் அலுவலகம் வீடுகளுக்கு விநியோகம் செய்யாது. கவுண்டர் சேவைகளுக்கு இங்கே வரவும்.',
    GO_TO_COORDINATES: 'ஆயத்தொலைவுகளுக்குச் செல்லவும்',
    CAT_COORDINATES: 'ஆயத்தொலைவுகள்',
    CAT_GLOBAL: 'உலகளாவிய இடங்கள்',

    // Tutorial
    TUTORIAL_WELCOME_TITLE: 'நம்ம மேப் V2-விற்கு வரவேற்கிறோம்',
    TUTORIAL_WELCOME_DESC: 'தமிழகத்தின் குடிமைச் சேவைகளைக் கண்டறிய உங்கள் ஒருங்கிணைந்த தளம். ஒரு சிறிய வழிகாட்டலைப் பார்ப்போம்!',
    TUTORIAL_LAYERS_TITLE: 'சேவை அடுக்குகள்',
    TUTORIAL_LAYERS_DESC: 'அஞ்சல் நிலையங்கள், ரேஷன் கடைகள், மின்சார வாரியம் மற்றும் சுகாதார மையங்கள் போன்ற பல்வேறு சேவைகளுக்கு இடையே மாறவும்.',
    TUTORIAL_SEARCH_TITLE: 'புத்திசாலித்தனமான தேடல்',
    TUTORIAL_SEARCH_DESC: 'ஒரு குறிப்பிட்ட மாவட்டம் முதல் தெரு முகவரி அல்லது அடையாளம் வரை எதையும் தேடுங்கள்.',
    TUTORIAL_LOCATE_TITLE: 'என்னைத் தேடு',
    TUTORIAL_LOCATE_DESC: 'GPS-ஐப் பயன்படுத்தி உங்கள் தற்போதைய இருப்பிடத்திற்கான சேவைகளை உடனடியாகக் கண்டறியவும்.',
    TUTORIAL_MAP_TITLE: 'ஊடாடும் வரைபடம்',
    TUTORIAL_MAP_DESC: 'வரைபடத்தில் எங்காவது கிளிக் செய்து, அந்த இடத்திற்கு எந்தச் சேவை அலுவலகம் பொறுப்பு என்பதைக் கண்டறியவும்.',
    TUTORIAL_LANG_TITLE: 'மொழி',
    TUTORIAL_LANG_DESC: 'எந்த நேரத்திலும் ஆங்கிலம் மற்றும் தமிழுக்கு இடையே மாறவும்.',
    TUTORIAL: 'வழிகாட்டி',
    POS_DEVICES: 'POS சாதனங்கள்',
    TOTAL_TRANSACTIONS: 'மொத்த பரிவர்த்தனைகள்',
    BANKS: 'வங்கிகள்',
    DIGITAL_PAYMENTS: 'டிஜிட்டல் கொடுப்பனவுகள்',
    NO_POS_DEVICES: 'இந்த கோயிலுடன் தற்போது POS சாதனங்கள் இணைக்கப்படவில்லை.',
  }
};

export type TranslationKey = keyof typeof translations.en;

export const useTranslation = () => {
  const language = useMapStore(state => state.language);

  const t = (key: TranslationKey): string => {
    return (translations[language] as any)[key] || (translations.en as any)[key] || key;
  };

  return { t, language };
};
